export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // 建银智能评估系统菜单
  'menu.operations': 'Operations Overview',
  'menu.customer': 'Customer Management',
  'menu.customer.customerAdd': 'Add Customer',
  'menu.customer.customerEdit': 'Edit Customer',
  'menu.task': 'Task Management',
  'menu.report': 'Report Management',
  'menu.activity': 'Activity Management',
  'menu.finance': 'Finance Management',
  'menu.platform': 'Platform Maintenance',
  'menu.netValueSolution': 'Net Value Solution',
  'menu.reportTemplate': 'Report Template Config',
  'menu.ledger': 'Ledger Management',
  'menu.inquiryBatch': 'Batch Inquiry',
  'menu.system': 'System Management',

  // 系统管理子菜单
  'menu.organization': 'Organization Management',
  'menu.dept': 'Department Management',
  'menu.district': 'District Management',
  'menu.logs': 'Operation Logs',
  'menu.user': 'User Management',
  'menu.personal': 'Personal Settings',
  'menu.role': 'Role Management',
  'menu.settings': 'System Settings',

  // 完整的系统管理子菜单路径
  'menu.system.organization': 'Organization Management',
  'menu.system.organizationAdd': 'Add Organization',
  'menu.system.organizationEdit': 'Edit Organization',
  'menu.system.organizationView': 'Organization Details',
  'menu.system.dept': 'Department Management',
  'menu.system.district': 'District Management',
  'menu.system.formProfile': 'Form Profile Pack',
  'menu.system.formProfileDetail': 'Form Profile Detail',
  'menu.system.certRecognizeEval': 'Ownership Cert Eval',
  'menu.system.logs': 'Operation Logs',
  'menu.system.user': 'User Management',
  'menu.system.userCreate': 'Add User',
  'menu.system.userEdit': 'Edit User',
  'menu.system.personal': 'Personal Settings',
  'menu.system.role': 'Role Management',
  'menu.system.roleCreate': 'Add Role',
  'menu.system.permission': 'Permission Management',
  'menu.system.menu': 'Menu Configuration',
  'menu.system.settings': 'System Settings',

  // 完整的客户管理子菜单路径
  'menu.customer.customerView': 'Customer Details',
  'menu.customer.customerUserCreate': 'Add Customer User',
  'menu.customer.customerUserEdit': 'Edit Customer User',

  // 完整的任务管理子菜单路径
  'menu.task.taskMyTask': 'My Tasks',
  'menu.task.taskStatistics': 'Task Statistics',
  'menu.task.taskSupplement': 'Task Supplement',
  'menu.task.taskSupplementEdit': 'Edit Task Supplement',
  'menu.task.taskCreate': 'Create Task',
  'menu.task.reportReview': 'My Review',
  'menu.task.reportDetail': 'Report Details',

  // 完整的报告管理子菜单路径
  'menu.report.reportStatistics': 'Report Statistics',
  'menu.report.reportDetail': 'Report Details',

  // Net value solution submenu
  'menu.netValueSolution.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolution.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolution.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolution.netValueSolutionPlanCustomParams': 'Plan Custom Parameters',
  'menu.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolutionPlanCustomParams': 'Plan Custom Parameters',

  // Report template submenu
  'menu.reportTemplate.reportTemplateList': 'Template Config List',
  'menu.reportTemplate.reportTemplateCommonParams': 'Common Parameters',
  'menu.reportTemplate.reportTemplateDetail': 'Template Version Config',
  'menu.reportTemplate.reportTemplateAdd': 'Add Report Config',
  'menu.reportTemplateList': 'Template Config List',
  'menu.reportTemplateCommonParams': 'Common Parameters',
  'menu.reportTemplateDetail': 'Template Version Config',
  'menu.reportTemplateAdd': 'Add Report Config',
};
